export const PAGE_PERMISSIONS = [
  { id: "blocks", label: "Blocks" },
  { id: "repairs", label: "Repairs" },
  { id: "special_considerations", label: "Special Considerations" },
  { id: "charges", label: "Charges" },
  { id: "statistics", label: "Statistics" },
];

export function isAdmin(user) {
  return hasPermission(user, "config.roles.delete");
}

export function hasLution(user, lution) {
  return Boolean(user?.lution_entitlements?.includes(lution));
}

export function hasPermission(user, permission) {
  if (!user) return false;
  // Stable permission keys are the only authority for new application features.
  return Array.isArray(user.permission_keys) && user.permission_keys.includes(permission);
}

export function hasAnyPermission(user, permissions) {
  return permissions.some((permission) => hasPermission(user, permission));
}

export function canAccessStage(user, stage) {
  if (!user) return false;
  return isAdmin(user) || user.allowed_stages?.includes("*") || (user.allowed_stages || []).includes(stage);
}

export function canAccessPage(user, page) {
  if (!user) return false;
  return isAdmin(user) || user.allowed_pages?.includes("*") || (user.allowed_pages || []).includes(page);
}
